import { render } from "./risks_dashboard.html?vue&type=template&id=64bd1593&external"
import script from "./risks_dashboard.js?vue&type=script&lang=js&external"
export * from "./risks_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__